<template>
  <div class="page-break">
    <el-row>
      <el-col :span="24">
        <p style="font-size: 25px;font-weight:600;width: 100%;text-align: center" v-if="this.抬头名称">
          {{ 抬头名称 }}</p>
        <p style="font-size: 25px;font-weight:600;width: 100%;text-align: center" v-else-if="Ishistory">
          {{ defaultTitle + '入库单' }}</p>
        <p style="font-size: 25px;font-weight:600;width: 100%;text-align: center" v-else>
          {{ defaultTitle + '采购单' }}</p>
      </el-col>
      <el-col v-if="topData.length > 0" :span="13" style="margin-top:5px;">
        <ul>
          <li>供应商：{{ topData[0].SUPPLIER_NAME }}</li>
          <li>收货方：{{ defaultTitle }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期：{{ topData[0].SEND_DAY }}</li>
          <li>入&nbsp;库&nbsp;日&nbsp;期：{{ CREATE_TIME }}</li>
          <li v-if="是否打印订单ID">订&nbsp;单&nbsp;ID：{{ topData[0].ORDER_ID }}</li>
        </ul>
      </el-col>
      <el-col :span="11" style="padding-left: 15px;margin-top:5px;">
        <ul>
          <li>制&nbsp;&nbsp;单&nbsp;&nbsp;人：{{ managername }}</li>
          <li>{{ topData[0].PROJECT_TELPHONE }}</li>
          <li>订&nbsp;单&nbsp;编号：{{ topData[0].ORDER_CODE }}</li>
          <li>制&nbsp;单&nbsp;日&nbsp;期：{{ topData[1] }}</li>
          <li>整&nbsp;单&nbsp;备注：{{ topData[0].REMARKS }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <div style="display:flex;">
       <div style="width:123%">
      <el-col :span="22" style="position:relative;">
        <table style="width: 100%" v-show="Ishistory">
          <tr class="aa">
            <th style="width: 5%">序号</th>
            <th style="width: 30%">名称</th>
            <th style="width: 10%" v-if="printCode == 1">编码</th>
            <th style="width: 10%">产品分类</th>
            <th style="width: 5%">单位</th>
            <th style="width: 8%">订购</th>
            <th style="width: 10%">实收</th>
            <th style="width: 8%">价格</th>
            <th style="width: 8%">总金额</th>
            <th style="width: 15%">备注</th>
          </tr>
          <tr v-for="(item, index) in mainData[0]" :key="index">
            <td>{{ item.ID }}</td>
            <td>{{ item.AFTER_NAME }}</td>
            <td v-if="printCode == 1">{{ item.AFTER_PRODUCT_CODE }}</td>
            <td>{{ item.GYSCATALOG_NAME }}</td>
            <td>{{ item.AFTER_TYPE_UNIT }}</td>
            <td>{{ item.BEFORE_COUNT }}</td>
            <td>{{ item.AFTER_COUNT }}</td>
            <td>{{ item.AFTER_PRICE }}</td>
            <td>{{ item.WORTH }}</td>
            <td>{{ item.PRODUCT_COMMENT }}</td>
          </tr>
        </table>
        <table style="width: 100%" v-show="!Ishistory">
          <tr class="aa">
            <th style="width: 5%">序号</th>
            <th style="width: 29%;word-break :break-all;">名称</th>
            <th v-if="catalogFlag == 1" style="width: 7%">产品分类</th>
            <th style="width: 5%">单位</th>
            <th style="width: 7%">订购</th>
            <th v-if="realCountFlag == 1" style="width: 8%">实收</th>
            <th style="width: 7%">价格</th>
            <th style="width: 7%">总金额</th>
            <th style="width: 5%" v-if="dateFlag == 1">生产日期</th>
            <th style="width: 7%" v-if="是否带库位 == 1">库位</th>
            <th style="width: 5%" v-if="是否带保质日期">保质日期</th>
            <th style="width: 8%">备注</th>
          </tr>
          <tr v-for="(item, index) in mainData[0]" :key="index">
            <td>{{ item.ID }}</td>
            <td>{{ item.PRODUCT_NAME }}</td>
            <td v-if="catalogFlag == 1">{{ item.CATALOG_NAME }}</td>
            <td>{{ item.TYPE_UNIT }}</td>
            <td>{{ item.PRODUCT_COUNT }}</td>
            <td v-if="realCountFlag == 1">{{ item.REAL_COUNT }}</td>
            <td>{{ item.GYS_PRICE }}</td>
            <td>{{ item.REAL_FEE }}</td>
            <td v-if="dateFlag == 1"></td>
            <td v-if="是否带库位 == 1"></td>
            <td v-if="是否带保质日期">{{item.QGP+ timeTypeList[item.QGP_TIME_TYPE]}}</td>
            <td>{{ item.PRODUCT_COMMENT }}</td>
          </tr>
        </table>
      </el-col>
      </div>
      <div style="display:flex;flex-direction: column;font-size:0;height:0">
        <span style="font-size:15px">白</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">存</span>
        <span style="font-size:15px">根</span>
        <div style="height:5px;"> </div>
        <span style="font-size:15px">红</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">客</span>
        <span style="font-size:15px">户</span>
        <div style="height:5px;"></div>
        <span style="font-size:15px">蓝</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">回</span>
        <span style="font-size:15px">单</span>
        <div style="height:5px;"> </div>
        <span style="font-size:15px">黄</span>
        <span style="font-size:15px">联</span>
        <span style="font-size:15px">发</span>
        <span style="font-size:15px">货</span>
      </div>
      </div>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="6">
        <span>收货时间：</span>
      </el-col>
      <el-col :span="6" style="margin-left: 37%">
        <span v-show="Ishistory">实收总金额：{{ this.TOTAL_FEE }}</span>
        <span v-show="!Ishistory">总金额：{{ topData[0].REAL_TOTAL_GYS_FEE }}</span>
      </el-col>
      <!-- <li v-if="topData[0].SHOW_PRICE == 1">总&nbsp;金&nbsp;额：{{topData[0].TOTAL_PROJECT_FEE}}</li> -->
    </el-row>
    <el-row v-show="!Ishistory  &&  tcId  !=  5903">
      <!-- <el-col :span="6">
                <span>主管：</span>
            </el-col>
            <el-col :span="6">
                <span>会计：</span>
            </el-col>
            <el-col :span="6">
                <span>验收：</span>
            </el-col>
            <el-col :span="6">
                <span>制单：</span>
            </el-col> -->
      <el-col :span="6">
        <span>制单人：</span>
      </el-col>
      <el-col :span="6">
        <span>采购员：</span>
      </el-col>
      <el-col :span="6">
        <span>审批人：</span>
      </el-col>
      <el-col :span="6">
        <span>审核人：</span>
      </el-col>
    </el-row>
    <el-row v-show="Ishistory  &&  tcId  !=  5903">
      <el-col :span="6">
        <span>收货人：</span>
      </el-col>
      <el-col :span="6">
        <span>仓库主管：</span>
      </el-col>
      <el-col :span="6">
        <span>审批人：</span>
      </el-col>
      <el-col :span="6">
        <span>审核人：</span>
      </el-col>
    </el-row>
    <el-row v-show="tcId  ==  5903">
      <el-col :span="6">
        <span>收货人：</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" :offset="20" style="padding: 0">
        <p>第{{ mainData[0].currentPage }}页/共{{ mainData[0].totalPage }}页</p>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    headerData: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    manager: String,
    supplier: String,
    title: String,
    IsPrintCode: String,
    totalAmount: Number,
  },
  data() {
    return {
      timeTypeList: ['', '年', '季', '月', '日', '时'],
      Ishistory: false,
      topData: [],
      mainData: [],
      managername: '',
      TOTAL_FEE: 0,
      imgUrl: '',
      printSupplier: '',
      CREATE_TIME: sessionStorage.getItem('IN_WAREHOUSE_CREATE_TIME'),
      printName: sessionStorage.getItem('supplierName'),
      sendFlag: sessionStorage.getItem('sendFlag'),
      printTitle: '',
      defaultTitle: sessionStorage.getItem('company'),
      抬头名称: sessionStorage.getItem('订单自定义名称'),
      是否打印订单ID: sessionStorage.getItem('打印订单ID'),
      flag: false,
      catalogFlag: sessionStorage.getItem('catalogFlag'),
      realCountFlag: sessionStorage.getItem('realCountFlag'), // 实收 1打印带实收 0 打印不带实收
      tcId: sessionStorage.getItem('tcId'),
      printCode: '',
      dateFlag: Number(sessionStorage.getItem('productionDate')),
      是否带库位: false,
      是否带保质日期: false,
    };
  },
  created() {
    this.topData = this.headerData;
    this.mainData.push(this.tableData);
    if (this.mainData[0].IsHistoryFalg) {
      this.Ishistory = true;
    } else {
      this.Ishistory = false;
    }
    this.managername = this.manager;
    if (this.totalAmount) {
      this.TOTAL_FEE = this.totalAmount.toFixed(2);
    }
    this.printTitle = this.title;
    this.printCode = this.IsPrintCode;
    this.imgUrl = `https://service.linkda.com.cn/file/barcode/${this.topData[0].ORDER_ID}.png`;
    if (Number(sessionStorage.getItem('realCountFlag')) !== 0) {
      this.flag = true;
    } else {
      this.flag = false;
    }
    if (Number(sessionStorage.getItem('是否带库位')) !== 0) {
      // 1 是用户选择带 打印是带库位的 0 打印是不带库位的
      this.是否带库位 = true;
    }
    if (Number(sessionStorage.getItem('是否带保质日期')) !== 0) {
      // 1 是用户选择带 打印是带保质日期的 0 打印是不带保质日期的
      this.是否带保质日期 = true;
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('productionDate');
    sessionStorage.removeItem('是否带保质日期');
    sessionStorage.removeItem('是否带库位');
    sessionStorage.removeItem('订单自定义名称');
    sessionStorage.removeItem('realCountFlag');
    sessionStorage.removeItem('打印订单ID');
  },
};
</script>
<style scoped>
ul {
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
}

li {
  list-style: none;
  font-size: 24px;
  line-height: 24px;
  color: #000;
  font-family: 黑体;
}

span {
  font-size: 24px;
  line-height: 24px;
  color: #000;
  font-family: 黑体;
}

table {
  border-collapse: collapse;
  width: 130%;
  border: 1px solid #000;
  font-weight: bold;
}

td,
th {
  border: 1px solid #000;
  text-align: center;
  font-weight: normal;
  font-size: 24px;
  height: 24px;
  font-family: 黑体;
  color: #000;
  /* white-space:nowrap;overflow:hidden;text-overflow:ellipsis; */
  white-space: nowrap;
  /* 因为设置了block，所以需要设置nowrap来确保不换行
      overflow: hidden; /* 超出隐藏结合width使用截取采用效果*/
  text-overflow: ellipsis;
  /* 本功能的主要功臣，超出部分的剪裁方式 */
  -o-text-overflow: ellipsis;
  /* 特定浏览器前缀 */
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/shortPrintTax.vue